import React from 'react';
import { observer } from 'mobx-react';
import PasswordRecoveryComponent from './Password-recovery.component';
import usePasswordRecovery from './usePasswordRecovery';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, store, lang, handlers } = usePasswordRecovery(onClose);

    return (
        <>
            <PasswordRecoveryComponent
                lang={lang.lang}
                loading={store.passwordRecoveryLoading}
                email={state.email}
                emailError={state.emailError}
                notExistError={store.notExistError}
                serverError={store.serverError}
                onEmailChange={handlers.handleEmailChange}
                onSendClick={handlers.handleSendClick}
                onInputClick={handlers.handleInputClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const PasswordRecoveryContainer = observer(Container);

export default PasswordRecoveryContainer;
